import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-brand-cream px-4 py-20 sm:py-28" data-id="element-118" data-mp="1o2vhap4uen6k">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl border border-brand-gold/50 bg-white p-8 text-center shadow-soft sm:p-12" data-id="element-119" data-mp="223y5p8jb89kn">
        <span className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full border border-brand-gold/50 bg-brand-goldSoft text-brand-gold" data-id="element-120" data-mp="14dl4pk0e8ico">
          <ShieldCheckIcon size={40} aria-hidden="true" data-id="element-121" data-mp="1ed25po4pa82b" />
        </span>
        <h2 className="mt-6 text-3xl font-semibold text-brand-ink sm:text-4xl" data-id="element-122" data-mp="qnpy2sp0u824">
          Votre achat est protégé pendant 7 jours
        </h2>
        <p className="mx-auto mt-7 max-w-2xl text-base leading-7 text-brand-muted" data-id="element-123" data-mp="lon3612r9i7v">
          Si le matériel n’est pas livré correctement ou si vous recevez un
          fichier incorrect ou défectueux, contactez notre support dans les 7
          jours suivant votre achat afin que nous puissions vérifier et
          résoudre le problème.
        </p>
      </motion.div>
    </section>;
}